// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d768440e","885":"2a094c92"}[chunkId] + ".chunk.js";
};